import React, { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function EmailAudit() {
  const [emailAudits, setEmailAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const search = searchParams.get("search");
    const page = parseInt(searchParams.get("page")) || 1;

    if (search) {
      setSearchTerm(search);
    }
    setCurrentPage(page);
    fetchEmailAudits(search, page);
  }, [searchParams]);

  const fetchEmailAudits = async (searchParam = "", page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");
      let url = `${apiUrl}fetch-email-audit-list?page=${page}&limit=${itemsPerPage}`;

      if (searchParam) {
        url += `&searchParam=${encodeURIComponent(searchParam)}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch email audits");
      }

      const result = await response.json();
      setEmailAudits(result.data.emails);

      if (result.data.totalCount) {
        setTotalPages(Math.ceil(result.data.totalCount / itemsPerPage));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchTerm) params.append("search", searchTerm);
    params.append("page", "1");
    navigate(`?${params.toString()}`);
  };

  const handleClear = () => {
    setSearchTerm("");
    navigate("?page=1");
  };

  const handlePageChange = (newPage) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", newPage.toString());
    navigate(`?${params.toString()}`);
  };

  const renderPagination = () => {
    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="text-center">
          Page {currentPage} of {totalPages}
        </div>

        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        {error}
      </div>
    );
  }

  return (
    <>
      <div className="dashboard-title mb-3">
        <h1>Email Audit</h1>
      </div>
      <div className="row mb-3 clearfix">
        <div className="col-12 col-lg-12">
          <div className="filters">
            <div className="row gx-2 clearfix">
              <div className="col-12 col-lg-4 col-xl-5">
                <div>
                  <input
                    type="text"
                    className="form-control"
                    id="search"
                    placeholder="Search by Control No, Email Template Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-3 col-xl-2">
                <button
                  className="btn btn-secondary w-100"s
                  onClick={handleSearch}
                >
                  Search
                </button>
              </div>
              <div className="col-12 col-lg-3 col-xl-2">
                <button className="btn btn-light w-100" onClick={handleClear}>
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row mb-3">
        <div className="col-12 col-xl-12">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Control No</th>
                  <th scope="col">Email Template Name</th>
                  <th scope="col">Created By</th>
                  <th scope="col">Status</th>
                  <th scope="col">Date Created</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {emailAudits.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  emailAudits.map((audit, index) => (
                    <tr key={audit._id}>
                      <th scope="row">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </th>
                      <td>{audit.controlNo}</td>
                      <td>{audit.emailName}</td>
                      <td>{audit.userName}</td>
                      <td>{audit.status}</td>
                      <td>{audit.createdAt}</td>
                      <td>
                        <Link to={`/email-audit-details/${audit._id}`}>
                          <i className="bi bi-eye me-2"></i>
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {emailAudits.length > 0 && renderPagination()}
          </div>
        </div>
      </div> */}
       <div className="w-full mb-3">
      <div className="w-full overflow-x-auto">
        <div className="min-w-full">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="w-16 px-3 py-3 text-left text-sm font-semibold text-gray-900">#</th>
                <th scope="col" className="w-32 px-3 py-3 text-left text-sm font-semibold text-gray-900">Control No</th>
                <th scope="col" className="w-96 px-3 py-3 text-left text-sm font-semibold text-gray-900">Email Template Name</th>
                <th scope="col" className="w-32 px-3 py-3 text-left text-sm font-semibold text-gray-900">Created By</th>
                <th scope="col" className="w-24 px-3 py-3 text-left text-sm font-semibold text-gray-900">Status</th>
                <th scope="col" className="w-32 px-3 py-3 text-left text-sm font-semibold text-gray-900">Date Created</th>
                <th scope="col" className="w-20 px-3 py-3 text-left text-sm font-semibold text-gray-900">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {emailAudits.length === 0 ? (
                <tr>
                  <td colSpan="7" className="px-3 py-4 text-center text-sm text-gray-500">
                    No records found
                  </td>
                </tr>
              ) : (
                emailAudits.map((audit, index) => (
                  <tr key={audit._id} className="hover:bg-gray-50">
                    <th scope="row" className="px-3 py-4 text-sm text-gray-500">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </th>
                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {audit.ControlNo}
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500">
                      <div className="max-w-full break-words">
                        {audit.emailName}
                      </div>
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {audit.userName}
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {audit.status}
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {audit.createdAt}
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500">
                      <Link to={`/email-audit-details/${audit._id}`} className="text-blue-600 hover:text-blue-800">
                        <i className="bi bi-eye"></i>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {emailAudits.length > 0 && renderPagination()}
        </div>
      </div>
    </div>
    </>
  );
}

export default EmailAudit;